module.exports = __webpack_public_path__ + "static/img/logo.9cfff05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gostart/logo.png
// module id = sDS6
// module chunks = 1